module.exports = __webpack_public_path__ + "static/media/17.2051a8f1.jpg";